var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.273 7.763a2.42 2.42 0 0 1 2.417 2.418v9.09a2.42 2.42 0 0 1-2.418 2.418h-9.09a2.42 2.42 0 0 1-2.418-2.418v-9.09a2.42 2.42 0 0 1 2.418-2.418zm-9.091 1.199a1.22 1.22 0 0 0-1.22 1.219v9.09c0 .673.547 1.218 1.22 1.218h9.09c.673 0 1.218-.545 1.218-1.218v-9.09c0-.673-.545-1.219-1.217-1.22zm3.636-6.653a2.423 2.423 0 0 1 2.418 2.418.6.6 0 0 1-1.2 0c0-.669-.55-1.22-1.218-1.22h-9.09c-.67 0-1.22.55-1.22 1.22v9.09c0 .669.551 1.218 1.22 1.218a.6.6 0 0 1 0 1.2 2.423 2.423 0 0 1-2.418-2.418v-9.09a2.423 2.423 0 0 1 2.418-2.418z"
  })));
};
export default SvgCopy;